/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FormW9RequestGetResponse,
    FormW9RequestResponse,
    FormW9StatusResponse,
    FormW9TinMatchByAdminRequest,
} from '../models';

export interface FormW9ApiControllerTinMatchByAdminRequest {
    formW9TinMatchByAdminRequest: FormW9TinMatchByAdminRequest;
}

/**
 * 
 */
export class FormW9Api extends runtime.BaseAPI {

    /**
     */
    async formW9ApiControllerGetRaw(): Promise<runtime.ApiResponse<FormW9RequestGetResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/form-w9`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async formW9ApiControllerGet(): Promise<FormW9RequestGetResponse> {
        const response = await this.formW9ApiControllerGetRaw();
        return await response.value();
    }

    /**
     */
    async formW9ApiControllerGetW9StatusRaw(): Promise<runtime.ApiResponse<FormW9StatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/form-w9/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async formW9ApiControllerGetW9Status(): Promise<FormW9StatusResponse> {
        const response = await this.formW9ApiControllerGetW9StatusRaw();
        return await response.value();
    }

    /**
     */
    async formW9ApiControllerPdfRaw(): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/form-w9:get-pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async formW9ApiControllerPdf(): Promise<object> {
        const response = await this.formW9ApiControllerPdfRaw();
        return await response.value();
    }

    /**
     */
    async formW9ApiControllerRequestRaw(): Promise<runtime.ApiResponse<FormW9RequestResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/form-w9:request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async formW9ApiControllerRequest(): Promise<FormW9RequestResponse> {
        const response = await this.formW9ApiControllerRequestRaw();
        return await response.value();
    }

    /**
     */
    async formW9ApiControllerTinMatchByAdminRaw(requestParameters: FormW9ApiControllerTinMatchByAdminRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.formW9TinMatchByAdminRequest === null || requestParameters.formW9TinMatchByAdminRequest === undefined) {
            throw new runtime.RequiredError('formW9TinMatchByAdminRequest','Required parameter requestParameters.formW9TinMatchByAdminRequest was null or undefined when calling formW9ApiControllerTinMatchByAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/form-w9:tin-match-by-admin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.formW9TinMatchByAdminRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async formW9ApiControllerTinMatchByAdmin(requestParameters: FormW9ApiControllerTinMatchByAdminRequest): Promise<void> {
        await this.formW9ApiControllerTinMatchByAdminRaw(requestParameters);
    }

}
